import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { TabPosition, TabStripComponent } from '@progress/kendo-angular-layout';
import { environment } from 'environments/environment';
import { finalize } from 'rxjs/operators';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { CustomFieldSummary } from '~/models/modules/customField';
import { DepartmentDto } from '~/models/modules/department';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { DepartmentsService } from '~/services/modules/assets/department';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { NoteComponent } from '~/shared/components/note/note.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { Observable } from 'rxjs';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { AccountsService } from '~/services/administration.ts/accounts';

@Component({
    selector: 'department-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class DeparmtentsUpsertComponent extends MultiSiteAwareComponent implements OnInit, OnDestroy {

  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('kendo_BarcodeGen_Department_Code') kendoInputdepartmentCode: ElementRef;
  @ViewChild('kendo_tabstrip') public screenTabStrip: TabStripComponent;
  // @ViewChild('note') note : NoteComponent;

  _theme: string;

  _currentUser: UserSummary;
  _isLiveEnterprise: boolean;

  _model: DepartmentDto;
  _active: boolean;
  _pageState: PageState;
  _page = 'departments';
  _permissionScope = 'departments';
  _entity = 'Common';
  _language = 'en';
  _form: FormGroup;


  okCloseSubscription: any = null;
  _gridFieldAuth: GridFieldAuthorization[];
  _editFormActive: boolean;
  _orderingTabsForm: boolean = false;
  _deactivatedFieldsForm: boolean = false;
  _deactivatedFormTabsForm: boolean = false
  _isAddTabFormValue: boolean = false;

  _deactivatedFieldsGridData: Array<any> = [];
  _deactivatedFormTabsGridData: Array<any> = [];
  _dataTabsSelected: Array<any> = [];

  _gridFieldText: GridFieldTextSummary[];

  _selectedLabelObjectCode: any;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _isMandatory: boolean = false;
  _requiredFields: Array<any> = [];
  _requiredFieldNames: Array<any> = [];
  _systemFields: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  code: string;
  name: string;


  _kendoTabStripPosition: TabPosition = 'left';
  _dataTabs: Array<any> = [];
  _userNewDataTabs: Array<any> = [];
  _customFields: CustomFieldSummary[][] = [];
  _selectedAccountIds: any[] = [];
  _invalidSubmit: boolean;
  _customFieldsValue: any = [];
  _selectedLabelId: number;
  _selectedTabId: number;
  _invalidForm: boolean;
  _custominvalidForm: boolean;
  _isCustomfieldsFormValue: boolean = false;
  _customTabs: any;
  _customFieldsDictionary: { [key: string]: string } = {};
  _isEditForms: boolean = false;
  _customRequiredFields: Array<any> = [];
  _customValidation: any = [];
  reactivate: boolean = false;
  reactivateItem: any;
  _isDialiog: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;

  copyModelId: number;

  // #region Enterprise Data
  _addClassActive: boolean = false;
  _selectedAccounts: any[] = [];
  declare _tabEnabled: boolean;

  // #endregion
  constructor(
    private _departmentsService: DepartmentsService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _sharedService: SharedService,
    private _securityService: SecurityService,
    private _themeManager: ThemeManagerService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _layoutManager: LayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _accountsService: AccountsService,
    private _fb: FormBuilder) {

    super();
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this.LoadData();
  }

  ngOnDestroy(): void {
  }
  ngOnInit(): void {
    this._initForm();
    this._viewInactiveFields(true);
    this._viewInactiveFormTabs(true);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.screenTabStrip != undefined) {
        this.screenTabStrip.selectTab(0);
      }
    }, 300);

  }

  async LoadData() {
    this._isLiveEnterprise = environment.liveEnterprise;
    this._currentUser = this._securityService.currentUser;
    this._getdata();
    this.getAuth();
    this.getFormTabs();
    this.getSystemFieldsAndCustomFields();
    //this.loadCustomFields(this._model?.id?.toString());
    await this.getCustomFields();
    await this.loadLabels();
    await this.fillForm();
  }

  _getAccounts = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  };
  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e);
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }

  _edit() {
    this._pageState = PageState.EDIT;
    // this.accountTab.selected = true;
    // this.accountTab.disabled = false;
    // this.GeneralTab.disabled = true;
    // this.stockInfoTab.disabled = true;
    // this.alternateStockItemTab.disabled = true;
    // this.picturesTab.disabled = true;
    // this.vendorsTab.disabled = true;
    // this.HistoricalDataTab.disabled = true;
    // this.PendingPOTab.disabled = true;
    // this.PendingSOTab.disabled = true;
    // this.PendingTransferRequest.disabled = true;
  }


  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        setTimeout(() => {
          if (this.screenTabStrip != undefined) {
            this.screenTabStrip.selectTab(0);
          }
        }, 300);
        //this.sortProduct(p => p.order, "ASC");
      });
  }



  private loadCustomFields(entityId?: string) {
    entityId = this.copyModelId?.toString() ?? this._model?.id?.toString();
    //this._pacer.start();
    this._customFieldsService
      .getCustomFields(this._entity, this._page, entityId)

      .subscribe((data) => {
        data.forEach((fieldData: CustomFieldSummary) => {
          if (fieldData.customFieldType.type.toLowerCase() == 'date') {
            if (fieldData.customFieldsData) {
              let _cutomfieldData = fieldData.customFieldsData.find(f => f.entityId == entityId);
              if (_cutomfieldData) {
                _cutomfieldData.value = new Date(_cutomfieldData.value).toDateString();
              }
            }
          }
        });
        data = data.filter(x => x.formTab?.page == this._page);
        if (this._model != null && (this._model.id != null || this.copyModelId != null)) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id ?? that.copyModelId;
          });
        }
        var tabIds = data
          .map((item) => item.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(
          data,
          (item: { formTabId: any }) => item.formTabId
        );
        let that = this;
        tabIds.forEach(function (formTabId) {
          that._customFields[formTabId] = grouped.get(formTabId);
        });
        if (this.copyModelId) {
          let CustomFieldsDataForCopy: any = {};
          grouped.forEach(element => {
            element.forEach((value: any) => {

              let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
              CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;
              if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
              if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            });
            this._customFieldsValueChanges(CustomFieldsDataForCopy, null);

          });
        }
        this._customFieldsService
          .getFormTabsByPage(this._page)

          .subscribe((data: any) => {
            //get custom tabs first
            this._customTabs = data.filter(
              (x: { isCustom: boolean }) => x.isCustom == true
            );
            this.setMandatoryFields();
          });
      });
    //this._pacer.start()

  }



  _reactivate(item: any) {
    this.reactivateItem = item;
    this.reactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  //this.loadCustomFields(this._model?.id?.toString());
                  this.getSystemFieldsAndCustomFields();
                  this.getFormTabs();
                  this._viewInactiveFields(true);
                  // this._deactivatedFieldsForm = false;
                } else {
                  return;
                }
              }
            }
            // this._deactivatedFieldsForm = false;
          });
        // this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }




  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }


  async fillForm() {
    if ((this._model && this._model.id > 0) || (this._pageState == PageState.ADD && this._model && this._model.name)) {
      this.code = this._model.code;
      this.name = this._model.name;
    }
  }



  getAuth() {
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }


  async getCustomFields() {
    this._customFieldsService
      .getDeactivatedCustomFields(this._entity, this._page)
      .pipe(finalize(() => { }))
      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      });
  }

  async loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
      })
  }


  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;

    if ((this._pageState === PageState.ADD || this._pageState === PageState.COPY) && this._model && this._model.id > 0) {
      this.copyModelId = this._model.id;
      this._model.id = null;
      this._model.code = null;
    }
    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW || this._pageState == PageState.COPY) {
      this._selectedAccounts = (this._model?.departmentAccounts ?? []).map(
        (x: any) => +(x?.account?.id ?? x?.accountId ?? x?.id ?? x)
      );
      this._selectedAccountIds = [...this._selectedAccounts];
      this._tabEnabled = this._selectedAccounts.length > 0;
    }
  }


  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }


  runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter)
      .subscribe((data: any) => {
        var result = data.result.toString()
        this._form.patchValue({
          code: data.result.toString(),
        });
        this.code = result;
      });
    if (this._pageState == PageState.ADD || this._pageState == PageState.COPY) {
      setTimeout(() => {
        this.kendoInputdepartmentCode.nativeElement.focus();
        let departmentCode = this.kendoInputdepartmentCode;
        departmentCode.nativeElement.classList.add('focusedInput');
      });
    }
  }


  generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService
      .getBarcode('locations', quantity);
  }



  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    } else {
      this._pageState = PageState.EDIT_FIELDS;
      // this._editFormActive = true;
      // this._isCustomfieldsFormValue = true;
    }
  }

  _returnAdNew() {
    if (this._deactivatedFormTabsGridData?.length == 0) {
      this._viewInactiveFormTabs(true);
    }

    this._pageState = PageState.ADD;
  }

  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }


  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
  }


  _reorderingtabs() {
    this._orderingTabsForm = true;
  }


  _onCancel() {
    this._closeForm();
  }


  _closeForm() {

    var closeComponent = {
      component: 'departments',
      isClosed: true
    }

    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('departments');
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};

  }


  _onSave(e: string) {
    this.submit(e);
  }



  _viewInactiveFields(onLoad: boolean = false) {
    this._customFieldsService
      .getDeactivatedCustomFields(this._entity, this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
        if (!onLoad)
          this._deactivatedFieldsForm = true;
      });
  }
  _viewInactiveFormTabs(onLoad: boolean = false) {
    this._customFieldsService
      .getDeactivatedCustomForms(this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFormTabsGridData = data;
        //  if(!onLoad)
        //  this._deactivatedFormTabsForm = true;
      });
  }

  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
        this.loadCustomFields(this.copyModelId?.toString() ?? this._model?.id?.toString());
        //this.setMandatoryFields();
      })
  }
  requiredSystemTabs: any = [];
  //   setMandatoryFields() {
  //     this._requiredFieldNames = [];
  //     this._requiredFields = [];
  //     this.requiredSystemTabs = [];
  //     setTimeout(() => {
  //       for (let item of this._systemFields) {
  //         if (
  //           item.gridFieldText?.isRequired &&
  //           item.page?.trimEnd('') == this._page
  //         ) {
  //           this._requiredFields.push(item);
  //         }
  //       }

  //       for (let item2 of this._customFields) {
  //         if (item2) {
  //           for (let item3 of item2) {
  //             if (item3.isRequired && item3.formTab?.page == this._page) {
  //               this._requiredFields.push(item3);
  //             }
  //           }
  //         }
  //       }

  //       this._requiredFields.forEach((element) => {
  //         if (!element.isCustomField && element.isCustomField == null) {
  //           var tabName = element.formTab;
  //           this._requiredFieldNames.push(tabName);
  //         }
  //         else
  //         {
  //           if(element.formTabId)
  //           {
  //             let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
  //             if(SystemFieldTab)
  //             this.requiredSystemTabs.push(SystemFieldTab);
  //           }
  //         }
  //       });
  // if(this.navTrigger)
  // {
  //   let tabElementList = this.navTrigger.nativeElement.querySelector('ul');


  //   Array.from(tabElementList.children).forEach((child: any) => {

  //       child.classList.remove('mendatoryTab');
  //   });


  //   Array.from(tabElementList.children).forEach((child: any) => {
  //     if (
  //       this._requiredFieldNames.find(
  //         (x) =>
  //           x.name === child.firstChild.innerText &&
  //           (x.page
  //             ? x.page.trimEnd('') == this._page
  //             : x.formTab.page.trimEnd('') == this._page)
  //       )
  //     )
  //     {
  //       child.classList.add('mendatoryTab');
  //     }
  //     if (
  //       this.requiredSystemTabs.find(
  //         (x : any) =>
  //           x.name === child.firstChild.innerText
  //       )
  //     ) {
  //       child.classList.add('mendatoryTab');
  //     }
  //   });
  // }



  //       // this._requiredFields.forEach((element) => {
  //       //   if (element.customFieldType) {
  //       //     this._customRequiredFields.push(element);
  //       //     let thisvalue =
  //       //       element.customFieldsData.filter(
  //       //         (x: any) => x.entityId == this._model.id
  //       //       ).length > 0
  //       //         ? element.customFieldsData.filter(
  //       //           (x: any) => x.entityId == this._model.id
  //       //         )[0].value
  //       //         : '';
  //       //     this._customValidation.push({
  //       //       name: element.name,
  //       //       value: thisvalue,
  //       //       tabName: element.formTab?.name,
  //       //     });
  //       //   }
  //       // });
  //     }, 500);
  //   }
  setMandatoryFields() {
    this._customValidation = [];
    //this.getSystemFields();
    //this.loadCustomFields(this._model?.id?.toString());
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (
          item.gridFieldText?.isRequired &&
          item.page?.trimEnd('') == this._page
        ) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired && item3.formTab?.page == this._page) {
              this._requiredFields.push(item3);
            }
          }
        }
      }

      this._requiredFields.forEach((element) => {

        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });
      if (this.navTrigger) {
        let tabElementList = this.navTrigger.nativeElement.querySelector('ul');
        if (tabElementList) {
          Array.from(tabElementList.children).forEach((child: any) => {

            child.classList.remove('mendatoryTab');
          });


          Array.from(tabElementList.children).forEach((child: any) => {
            if (child.firstChild.innerText == 'General') {
              child.classList.add('mendatoryTab');
            }
            if (child.firstChild.innerText == 'Costing') {
              child.classList.add('mendatoryTab');
            }
            if (
              this._requiredFieldNames.find(
                (x) =>
                  x.name === child.firstChild.innerText &&
                  (x.page
                    ? x.page.trimEnd('') == this._page
                    : x.formTab.page.trimEnd('') == this._page)
              )
            ) {
              child.classList.add('mendatoryTab');
            }
            if (
              this.requiredSystemTabs.find(
                (x: any) =>
                  x.name === child.firstChild.innerText
              )
            ) {
              child.classList.add('mendatoryTab');
            }
          });
        }
      }

      this._requiredFields.forEach((element) => {
        if (element.customFieldType) {
          this._customRequiredFields.push(element);
          let thisvalue =
            element.customFieldsData.filter(
              (x: any) => x.entityId == (this._model.id ?? this.copyModelId)
            ).length > 0
              ? element.customFieldsData.filter(
                (x: any) => x.entityId == (this._model.id ?? this.copyModelId)
              )[0].value
              : '';

          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });
    }, 500);
  }
  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }
  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }
  // _closeInactiveFormTabs() {
  //   this._deactivatedFormTabsForm = false;
  // }
  private _initForm() {
    this._form = this._fb.group({
      code: [this._model && this._model.code, Validators.required],
      name: [
        this._model && this._model.name,
        this.getLabel('LBL_DepartmentName')?.isRequired ? Validators.required : null,
      ],
    });
  }
  _additionalErrors: any = [];
  private submit = (e: string) => {
    this._additionalErrors = [];
    // if(!this.code || this.code.length == 0){
    //     this._layoutComponent.openPopup({
    //         title: 'Validation',
    //         message: 'Please fill the department code',
    //         withoutConfirm: true
    //       });
    //     return false;
    // }
    var sitesSelected: boolean = true;
    if (this._currentUser.isEnterprise) {
      if (this._currentUser.isEnterprise && this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select account(s) to continue.',
        });
        return false;
      }

    }
    if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._invalidForm = true;
      this._invalidSubmit = true;
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
    } else if (this._form.invalid) {
      this._invalidForm = true;
    } else if (this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidSubmit = true;
      this._invalidForm = true;
    }
    else {

      // var departmentRequest : any = {
      //     code : this.code,
      //     name : this.name
      // }
      const departmentRequest = this._form.value;
      // work with custom fields
      if (this._customFieldsValue) {
        // const entries = Object.entries(this._customFieldsValue);
        // for (const [index, [key, value]] of entries.entries()) {
        //   this._customFieldsDictionary[key] = `${value}`;
        // }

        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });

        departmentRequest['customFieldsValue'] = this._customFieldsDictionary;
      }
      departmentRequest['accountIds'] = this._selectedAccounts.map((c) => (c?.accountId != null ? +c.accountId : +c));
      if (!this._model || !this._model.id) {
        this._departmentsService
          .createDepartment(departmentRequest)

          .subscribe((response: any) => {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            // this.note.createNote(response.id);
            if (e === 'saveAndClose') {
              this._closeForm();
            }
            else if (e === 'saveAndCopy') {
              //this.copyModelId=this._model.id;
              this._model.id = undefined;
              this._pageState = PageState.ADD;
              this.code = null;
              this._form.controls.code.setValue(null);
              //this.loadCustomFields(this.copyModelId.toString());
            }
            else if (e === 'saveAndNew') {
              // this._model.id = undefined;
              // this._active = false;
              this.openUpsert(this._page, {}, PageState.ADD);
              // this.code = null;
              // this.name = null;
            }
            else if (e === 'save') {
              this._pageState = PageState.EDIT;
              this._model.id = response.responseId;
            }
          },
            // (error: any) => {
            //     this._layoutComponent.openPopup({
            //         title: 'Error',
            //         message: 'Cannot create a department with a same code',
            //         withoutConfirm: true
            //       });
            //     return false;
            // }
          );
      }
      else {
        this._departmentsService
          .updateDepartment(this._model.id, departmentRequest)

          .subscribe((response: any) => {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (e === 'saveAndClose') {
              this._closeForm();
            }
            else if (e === 'saveAndCopy') {
              this._pageState = PageState.ADD;
              this.copyModelId = this._model.id;
              this._model.id = undefined;
              this.code = null;
              this._form.controls.code.setValue(null);
              this.loadCustomFields(this.copyModelId.toString());
            }
            else if (e === 'saveAndNew') {
              // this._initForm();
              // this._form.reset();
              // this._pageState = PageState.ADD;
              // this._customFieldsValue = undefined;
              // this._model.id = undefined;
              // this._form.controls.code.setValue(null);
              // this._active = false;
              this.openUpsert(this._page, {}, PageState.ADD);
              // this.code = null;
              // this.name = null;
            }
          },
            // (error: any) => {
            //     this._layoutComponent.openPopup({
            //         title: 'Error',
            //         message: 'Cannot create a department with a same code',
            //         withoutConfirm: true
            //       });
            //     return false;

            //   }

          );
      }

    }

  }
  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }


  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null;

      return result ? result : null;
    }
  }



  _onTabSelect(e: any) {
    this._mobileMenuToggle();
  }



  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }


  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    // Object.keys(customFieldsValue).forEach(key => {
    //   if (customFieldsValue[key] == null || customFieldsValue[key] == 'null') {
    //     customFieldsValue[key] = '';
    //   }
    //   if(this._customFields[tabId] && this._customFields[tabId].find(x => x.name == key))
    //   {
    //     if (this._customFields[tabId].find(x => x.name == key)?.entityId == undefined
    //   || this._customFields[tabId].find((x) => x.name == key).customFieldsData.length == 0
    //   ) {//new mode, custom field data not added yet
    //     this._customFields[tabId].find(x => x.name == key).entityId = -1;
    //     this._customFields[tabId].find(x => x.name == key).customFieldsData.push({ id: -1, value: 'null', entityId: -1,customFieldId:-1 });
    //   }
    //   var customFieldData = this._customFields[tabId].find(x => x.name == key).customFieldsData.find(x => x.entityId == this._customFields[tabId].find(x => x.name == key).entityId);
    //   if (customFieldData != undefined) {
    //     customFieldData.value = customFieldsValue[key];
    //   }
    //   }

    // });
    // this._customFieldsValue = customFieldsValue;
    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }

      this._customFieldsValue.push(customObject);
    });
  }

  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex(x => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter(x => x.id != customFieldId);
          this.setMandatoryFields();
          this._viewInactiveFields(true);
          return;
        }
      }
    }
  }



  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }


  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }


  _addNewField(tabId: number) {
    this._selectedTabId = null
    this._selectedTabId = tabId;
    this._selectedLabelId = undefined;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }


  reactivateTab: boolean;
  _reactivateFormTab(item: any) {
    this.reactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      this.reactivateTab = true;
      if (boolData && this.reactivateTab) {
        // if (boolData && this.reactivateTab && (this.lastTabIdReactivated.length == 0 || !this.lastTabIdReactivated.includes(item.id))) {
        this.reactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService
          .reactivateFormTab(item.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              // if (this.lastTabIdDeactivated.includes(item.id)) {
              //   this.lastTabIdDeactivated = this.lastTabIdDeactivated.filter(id => id !== item.id);
              // }
              // this.lastTabIdReactivated.push(item.id);
              this._viewInactiveFormTabs(false)
              this._customFieldsService
                .getFormTabsByPage(this._page)

                .subscribe((data: any) => {
                  //get custom tabs first
                  this.getFormTabs();
                  this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
                });
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this.reactivateTab = false;
      }
      sub.unsubscribe();
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  _closeInactiveFormTabs() {
    this._deactivatedFormTabsForm = false;
  }
  // lastTabIdDeactivated:number[] = []
  // lastTabIdReactivated:number[] = []
  //#endregion
  deactivateTab: boolean
  _deactivateTab(tabId: number, page: string) {
    this.deactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      if (boolData && this.deactivateTab) {
        // if (boolData && this.deactivateTab && (this.lastTabIdDeactivated.length == 0 || !this.lastTabIdDeactivated.includes(tabId))) {
        this.deactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
          // this.lastTabIdDeactivated.push(tabId);
          // if (this.lastTabIdReactivated.includes(tabId)) {
          //   this.lastTabIdReactivated = this.lastTabIdReactivated.filter(id => id !== tabId);
          // }

          if (response != null && response['message'] != null) {
            this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
              //get custom tabs first
              this.getFormTabs();
              this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
            });

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                // this._closeForm();
              }
              else {
                return;
              }
            }
          }
        });
      } else {
        this.deactivateTab = true;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Deactivate This Tab?',
    });

  }

  // _deactivateTab(tabId: number, page: string) {
  //   let model: any = {
  //     customFieldEntityId: page == 'locationTypes' ? 1 : 2,
  //     page: this._page,
  //     accountIds: this._selectedAccountIds,
  //   };
  //     .deleteCustomTab(tabId, model)
  //     
  //     .subscribe((response: any) => {
  //       if (response != null && response['message'] != null) {
  //         var deletedTab = this._dataTabs.find(f => f.id == tabId && f.isCustom == true);
  //         this._dataTabs.splice(this._dataTabs.indexOf(deletedTab),1);
  //         //go to zero based tab
  //         this.screenTabStrip.selectTab(0);
  //         //   .getFormTabsByPage(this._page)
  //         //   
  //         //   .subscribe((data: any) => {
  //         //     //get custom tabs first
  //         //     this.getFormTabs();
  //         //     this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);

  //         //     var deletedTab = this._dataTabs.find(f => f.id == tabId && f.isCustom == true);
  //         //     this._dataTabs.splice(this._dataTabs.indexOf(deletedTab),1);
  //         //     //go to zero based tab
  //         //     this.screenTabStrip.selectTab(0);
  //         //   });
  //         this._layoutComponent.openPopup({
  //           title: 'Alert',
  //           message: response['message'],
  //           withoutConfirm: true
  //         });
  //         if (response['close'] != null) {
  //           if (response['close'] == true) {
  //             // this._closeForm();
  //           } else {
  //             return;
  //           }
  //         }
  //       }
  //       //   this._closeForm();
  //     });

  // }
  // _reactivateFormTab(item: any) {
  //   this.reactivateItem = item;
  //   this.reactivate = true;
  //   this._sharedService.okCloseClicked.subscribe((data:boolean) => {
  //       if (data && this.reactivate) {
  //         this.reactivate = false;
  //         let model: any = {
  //           customFieldEntityId: this._page == 'locationTypes' ? 1 : 2,
  //           page: this._page,
  //           accountIds: this._selectedAccountIds,
  //         };
  //           .reactivateFormTab(item.id, model)
  //           
  //           .subscribe((response: any) => {
  //             if (response != null && response['message'] != null) {
  //                 .getFormTabsByPage(this._page)
  //                 
  //                 .subscribe((data: any) => {
  //                   //get custom tabs first
  //                   this.getFormTabs();
  //                   this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
  //                 });
  //               this._layoutComponent.openPopup({
  //                 title: 'Alert',
  //                 message: response['message'],
  //                 withoutConfirm: true
  //               });
  //               if (response['close'] != null) {
  //                 if (response['close'] == true) {
  //                   // this._closeForm();
  //                 } else {
  //                   return;
  //                 }
  //               }
  //             }
  //             //   this._closeForm();
  //           });
  //         this._deactivatedFormTabsForm = false;
  //       } else {
  //           this.reactivate = false;
  //       }
  //   });


  //   this._layoutComponent.openPopup({
  //     title: 'Notification',
  //     message: 'Are you sure you want to Reactivate ' + item.name
  //   });
  //  //this.loadCustomFields(this._model?.id?.toString());
  //  this.getSystemFieldsAndCustomFields();
  // }



  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }



  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._closeOrderingTabsForm();
      })
  }


  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find(x => x.order == i + 1)) {
      this._userNewDataTabs.find(x => x === this._dataTabsSelected.find(x => x.order == i + 1)).order =
        this._dataTabsSelected.find(x => x.name === e.name).order;
    }
    this._userNewDataTabs.find(obj => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter(obj => obj !== e);
  }

  _hasCustomTabs() {
    return this._dataTabs.find((x: any) => x.isCustom);
  }
  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }
}
